import {combineReducers} from 'redux';

import {Paging, Sorting} from 'helpers/constants';
import {priceListActionTypes} from 'actions/actionTypes';

import priceListItem from './priceListItemReducer';

const initialState = {
  isLoading: false,
  deleteLoading: false,
  searchString: '',
  filterOption: 'ActiveOnly',
  pageInfo: {
    pageNumber: 1,
    pageSize: Paging.initialPageSize,
    pageSizes: Paging.pageSizes,
  },
  sortInfo: {
    sortOrder: Sorting.asc,
    sortColumn: 'qualifiedName',
  },
  items: null,
  itemTypes: [],
  previewItems: [],
  parentCount: 0,
  allChecked: false,
  deletedItems: [],
  selectedCount: 0,
  totalRows: 0,
};

const allItems = (state = initialState, action) => {
  switch (action.type) {
    case priceListActionTypes.GET_PRICE_LIST_SUCCESS:
      return {
        ...state,
        items: action.items,
        allChecked: false,
        selectedCount: 0,
        searchString: action.searchString,
        totalRows: action.totalRows,
        isLoading: false,
      };

    case priceListActionTypes.GET_PREVIEW_LIST_SUCCESS:
      return {...state, previewItems: action.items, isLoading: false};

    case priceListActionTypes.PRICE_LIST_SEARCH_STRING_CHANGED:
      return {...state, searchString: action.searchString};

    case priceListActionTypes.PRICE_LIST_PAGE_CHANGED:
      return {
        ...state,
        pageInfo: {
          ...state.pageInfo,
          pageNumber: action.pageNumber,
          pageSize: action.pageSize,
        },
      };

    case priceListActionTypes.PRICE_LIST_SORT_CHANGED:
      return {
        ...state,
        sortInfo: {sortOrder: action.sortOrder, sortColumn: action.sortColumn},
      };

    case priceListActionTypes.PRICE_LIST_LOADING:
      return {...state, isLoading: true};

    case priceListActionTypes.PRICE_LIST_LOADING_COMPLETE:
      return {...state, isLoading: false};

    case priceListActionTypes.PRICE_LIST_LOADING_ERROR:
      return {...state, isLoading: false, items: []};

    case priceListActionTypes.PRICE_LIST_FILTER_OPTION_CHANGED:
      return {...state, filterOption: action.filterOption};

    case priceListActionTypes.PRICE_LIST_ITEM_CHECK_CHANGED: {
      const {items} = state;
      const allChecked = false;
      const updatedItems =
        items &&
        items.map(i => ({
          ...i,
          isChecked:
            i.priceListItemId === action.item.priceListItemId
              ? !i.isChecked
              : i.isChecked,
        }));
      return {
        ...state,
        allChecked,
        selectedCount: updatedItems.filter(i => !!i.isChecked).length,
        items: updatedItems,
      };
    }

    case priceListActionTypes.PRICE_LIST_ALL_CHECKED_CHANGED: {
      const {items} = state;
      const updatedItems =
        items && items.map(i => ({...i, isChecked: action.isChecked}));
      return {
        ...state,
        allChecked: action.isChecked,
        selectedCount: action.isChecked ? updatedItems.length : 0,
        items: updatedItems,
      };
    }

    case priceListActionTypes.LOAD_ITEM_TYPES_SUCCESS: {
      return {...state, itemTypes: action.items};
    }

    case priceListActionTypes.PRICE_LIST_DELETE_LOADING: {
      return {...state, deleteLoading: true};
    }

    case priceListActionTypes.PRICE_LIST_DELETE_COMPLETE: {
      return {...state, deleteLoading: false};
    }

    default:
      return state;
  }
};

export default combineReducers({
  allItems,
  editItem: priceListItem,
});



// WEBPACK FOOTER //
// ./src/reducers/priceListReducer.js